import React from "react";
import Typography from "@material-ui/core/Typography";
const Platform_v1_0_0 = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Invifo Platform Version 1.0.0
      </Typography>
      <Typography paragraph variant="h6">
        You can come back to this page and switch the version of the docs you're
        reading at any time.
      </Typography>
      <Typography paragraph variant="body1">
        The most recent stable version (✓) is recommended for use in production.
        The currenct stable version is version 1.0.0.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Version 1.0.0 - Release notes
      </Typography>
      <Typography paragraph variant="body1">
        This is the initial version of the Invifo Core Platform which contains
        the core functions and features including some modules like CRM, Sales,
        Inventory, Procurement, and Finance. This version also includes various
        dashboards and reports on each module.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Major Changes in version 1.0.0
      </Typography>
      <Typography paragraph variant="body1">
        There are no changes have been made to this version since this is the
        initial version
      </Typography>
    </React.Fragment>
  );
};

export default Platform_v1_0_0;
